import Popover from "@mui/material/Popover";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import React, {Fragment, useEffect, useState} from "react";
import {IDataDiscipline, IDataDisciplineBonus, IDataDisciplineDefence} from "../_interfaces/IDataDiscipline";
import disziplinen from "../_data/disziplinen";
import {InfoDisciplineBehaveSubscriber} from "../_helper/InfoDisciplineBehave"

function DisciplinePopover() {

    const [discipline, setDiscipline] = useState<IDataDiscipline | null>(null);
    const [disciplineAncor, setDisciplineAncor] = useState<HTMLElement | Element | null>(null);
    const [disciplineOpen, setDisciplineOpen] = useState(false);
    const [karma, setKarma] = useState<string[]>([]);
    const [add, setAdd] = useState<string[]>([]);
    const [bonus, setBonus] = useState<string[]>([]);

    const bonis = {'mr': 'Mystische Rüstung', 'ep': 'Erholungsproben', 'ini': 'Initiative'}

    useEffect(() => {
        const subscription = InfoDisciplineBehaveSubscriber.subscribe((newValue) => {
            setDisciplineAncor(newValue.popEl)
            setDiscipline(newValue.pop);
            setDisciplineOpen(newValue.popOpen)
            if (newValue && newValue.pop && newValue.pop.name) {
                const diszipline = disziplinen.find(d => d.name === newValue?.pop?.name)

                if (diszipline) {
                    let k: string[] = [];
                    if (diszipline.TuF[1].karma) k.push('Kreis 1 ' + diszipline.TuF[1].karma)
                    k.push('Kreis 3 ' + diszipline.TuF[3].karma)
                    k.push('Kreis 9 ' + diszipline.TuF[9].karma)
                    k.push('Kreis 11 ' + diszipline.TuF[11].karma)
                    setKarma(k)

                    let ad: string[] = [];
                    diszipline.TuF[5].add.map(a => ad.push('Kreis 5 ' + a))
                    diszipline.TuF[9].add.map(a => ad.push('Kreis 9 ' + a))
                    diszipline.TuF[13].add.map(a => ad.push('Kreis 13 ' + a))
                    setAdd(ad)

                    setBonus(bonusNNRaised(diszipline))
                }
            }
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const bonusNNRaised = (diszipline: IDataDiscipline) => {
        let ret: string[] = [];
        let lastv: IDataDisciplineDefence = {k: 0, m: 0, s: 0}
        let lastb: IDataDisciplineBonus = {ep: 0, ini: 0, mr: 0}
        for (let i = 1; i <= 15; i++) {
            let add: string[] = [];
            const b = diszipline.TuF[i].b as IDataDisciplineBonus;
            if (b.ep !== 0 && b.ep > lastb.ep) add.push('Erholungsproben +' + b.ep)
            if (b.mr !== 0 && b.mr > lastb.mr) add.push('Mystische Rüstung +' + b.mr)
            if (b.ini !== 0 && b.ini > lastb.ini) add.push('Initiative +' + b.ini)
            lastb = b;
            const v = diszipline.TuF[i].v as IDataDisciplineDefence;
            if (v.k !== 0 && v.k > lastv.k) add.push('Körperliche Verteidigung +' + v.k)
            if (v.s !== 0 && v.s > lastv.s) add.push('Soziale Verteidigung +' + v.s)
            if (v.m !== 0 && v.m > lastv.m) add.push('Magische Verteidigung +' + v.m)
            lastv = v;
            if (add.length > 0) ret.push('Kreis ' + i + ': ' + add.join(', '))
        }
        return ret
    }

    const handleClose = () => {
        setDisciplineAncor(null)
        setDiscipline(null)
        setDisciplineOpen(false);
    }

    if (disciplineOpen && discipline) return <Popover
        open={disciplineOpen}
        anchorEl={disciplineAncor}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
    >
        <Grid container spacing={1} style={{padding: 10}}>
            <Grid item xs={10}>
                {discipline?.name}
            </Grid>
            <Grid item xs={2}>
                <Button onClick={() => handleClose()}>X</Button>
            </Grid>
            <Grid item xs={12}>
                <div>Beschreibung:</div>
                <div>{discipline?.descr}</div>
            </Grid>
            <Grid item xs={12}>
                <div>Karmaritual:</div>
                <div>{discipline?.karmaritual}</div>
            </Grid>
            <Grid item xs={12}>
                <div>Halbmagie:</div>
                <div>{discipline?.halbmagie}</div>
            </Grid>
            <Grid item xs={12}>
                <div>Karmaverbesserungen:</div>
                <ul>{karma.map(a => <li>{a}</li>)}</ul>
                <div>Zusätzlich:</div>
                <ul>{add.map(a => <li>{a}</li>)}</ul>
                <div>Bonies:</div>
                <ul>{bonus.map(a => <li>{a}</li>)}</ul>
            </Grid>
        </Grid>
    </Popover>

    return <Fragment/>
}

export default DisciplinePopover;